// extracted by mini-css-extract-plugin
module.exports = {"form":"bh6fH","block":"hvvYh","primary":"lF4Yx","secondary":"J2CcX","control":"jLfzn","btn":"on645","icon":"MchTC","error":"K3RAE","theme_air":"Y97Dz"};